import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import { t } from 'i18next';
import { ChangeEventHandler } from 'react';
import { TableInstance } from 'react-table';
import { SearchIcon } from '~components/ui/icons';
import { UserCustomersTable_CustomerFragment as CustomerFragment } from './__generated__/UserCustomersTable.graphql';
import { Columns } from './types';

type Props = {
  table: TableInstance<CustomerFragment>;
};

export function UserCustomersTableFilter({ table }: Props) {
  const handleCustomerSearch: ChangeEventHandler<HTMLInputElement> = (event) => {
    table.setFilter(Columns.Name, event.target.value ?? '');
  };

  return (
    <InputGroup width="full" marginTop="6">
      <InputLeftElement pointerEvents="none" height="full">
        <SearchIcon color="gray.500" />
      </InputLeftElement>
      <Input
        type="search"
        placeholder={t('searchCustomers')}
        onChange={handleCustomerSearch}
        height="12"
      />
    </InputGroup>
  );
}
